var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3632 19.4009L18.5888 22.6265L25.04 16.1753M4.07361 14.5625C5.35683 14.5625 6.5875 15.0723 7.49487 15.9797C8.40225 16.887 8.91201 18.1177 8.91201 19.4009C8.91201 20.6842 8.40225 21.9148 7.49487 22.8222C6.5875 23.7296 5.35683 24.2393 4.07361 24.2393V27.4649C4.07361 28.3204 4.41345 29.1409 5.01836 29.7458C5.62328 30.3507 6.44373 30.6905 7.29921 30.6905H33.104C33.9595 30.6905 34.7799 30.3507 35.3849 29.7458C35.9898 29.1409 36.3296 28.3204 36.3296 27.4649V24.2393C35.0464 24.2393 33.8157 23.7296 32.9083 22.8222C32.001 21.9148 31.4912 20.6842 31.4912 19.4009C31.4912 18.1177 32.001 16.887 32.9083 15.9797C33.8157 15.0723 35.0464 14.5625 36.3296 14.5625V11.3369C36.3296 10.4814 35.9898 9.661 35.3849 9.05608C34.7799 8.45117 33.9595 8.11133 33.104 8.11133H7.29921C6.44373 8.11133 5.62328 8.45117 5.01836 9.05608C4.41345 9.661 4.07361 10.4814 4.07361 11.3369V14.5625Z",
    stroke: "white",
    strokeWidth: 1.6128,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketCheck);
export default __webpack_public_path__ + "static/media/ticket-check.598b16f72b2a3e2b160cf30ceaa7308b.svg";
export { ForwardRef as ReactComponent };